import { useLeadSalesSummary } from './api'
import { ErrorState, Loading } from '../../ui'

export default function SalesSourceSummary({ companyId }: { companyId: string }) {
  const query = useLeadSalesSummary(companyId)
  if (query.isLoading) return <div className="card"><Loading lines={2} /></div>
  if (query.error) return <ErrorState error={query.error} onRetry={() => void query.refetch()} />

  const summary = query.data!
  return (
    <section className="card stack" aria-labelledby="sales-source-title" style={{ gap: 10 }}>
      <div className="row between wrap" style={{ gap: 8 }}>
        <div>
          <h2 id="sales-source-title">Receita registrada por origem</h2>
          <p className="small muted">Vendas e recompras confirmadas informadas manualmente. Cancelamentos e estimativas de mídia ficam fora deste total.</p>
        </div>
        <div className="small"><span className="muted">Total registrado</span><br /><b>{formatCents(summary.totalAmountCents)}</b> · {summary.totalSaleCount} venda(s)</div>
      </div>
      {summary.items.length === 0 ? <p className="small muted">Nenhuma venda confirmada ainda.</p> : (
        <div className="table-wrap">
          <table className="table">
            <thead><tr><th>Origem do contato</th><th>Vendas confirmadas</th><th>Receita registrada</th></tr></thead>
            <tbody>
              {summary.items.map((item) => <tr key={item.source ?? 'unknown'}>
                <td>{item.source ?? <span className="muted">Sem origem registrada</span>}</td>
                <td>{item.saleCount}</td>
                <td className="strong">{formatCents(item.amountCents)}</td>
              </tr>)}
            </tbody>
          </table>
        </div>
      )}
    </section>
  )
}

function formatCents(value: string) {
  const cents = BigInt(value)
  const whole = cents / 100n
  const fraction = String(cents % 100n).padStart(2, '0')
  return `R$ ${whole.toLocaleString('pt-BR')},${fraction}`
}
